export default "__VITE_ASSET__CE$_sYCE__"